import { FC } from 'react'

import { ISvgClass } from '../interface'

const NotebookIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M3 18H21V5C21 4.73478 20.8946 4.48043 20.7071 4.29289C20.5196 4.10536 20.2652 4 20 4H4C3.73478 4 3.48043 4.10536 3.29289 4.29289C3.10536 4.48043 3 4.73478 3 5V18ZM2 20H22C23 20 23 19 23 19H1C1 19 1 20 2 20Z"
        stroke="black"
        stroke-width="2"
        fill="inherit"
      />
    </svg>
  )
}

export default NotebookIcon
